import React, { useState, useEffect } from "react";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import PropTypes from "prop-types";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, Typography, Box, IconButton } from "@mui/material";
import { useSnackbar } from "components/GlobalSnackbar";
import CloseIcon from '@mui/icons-material/Close';
import { apiUploadNotis } from '../../api/notis';
import { getCurrentUser } from '../../utils/userUtils';
import { buttonStyles } from "utils/buttonStyles";
import { dialogHeaderStyles } from "utils/dialogStyles";

function TambahTerimaNotis({ open, onClose, onUpload, accounts = [] }) {
  const [tarikh_borang, setTarikhBorang] = useState("");
  const [tarikh_notis, setTarikhNotis] = useState("");
  const [files, setFiles] = useState([]); // Array of files
  const [isPdf, setIsPdf] = useState(true); // Assume true by default for empty
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;

  const { showSuccess, showError, showWarning, showInfo } = useSnackbar();

  useEffect(() => {
    setPage(0);
  }, [accounts, open]);

  const resetForm = () => {
    setTarikhBorang("");
    setTarikhNotis("");
    setFiles([]);
    setIsPdf(true);
  };

  const handleFileChange = (e) => {
    const chosenFile = e.target.files[0];
    if (chosenFile) {
      setFiles([chosenFile]);
      setIsPdf(chosenFile.type === "application/pdf" && chosenFile.name.toLowerCase().endsWith('.pdf'));
    } else {
      setFiles([]);
      setIsPdf(true);
    }
  };

  const handleRemoveFile = (name) => {
    const updatedFiles = files.filter(f => f.name !== name);
    setFiles(updatedFiles);
    const allPdf = updatedFiles.every(f => f.type === "application/pdf" && f.name.toLowerCase().endsWith('.pdf'));
    setIsPdf(allPdf);
  };

  const handleUpload = async () => {
    if (files.length === 0 || !tarikh_borang || !tarikh_notis || !isPdf) {
      showError("Sila isi Tarikh Borang, Tarikh Notis dan pilih fail PDF untuk dimuat naik.");
      return;
    }
    const user = getCurrentUser();
    if (!user) {
      showError("Tidak dapat mengenal pasti pengguna. Sila log masuk semula.");
      return;
    }
  const today = new Date().toISOString().slice(0, 10);
  const onlyDate = (v) => (v ? new Date(v).toISOString().slice(0, 10) : "");
    // Build notisList for each account
  const notisList = accounts.map(acc => ({
      no_akaun: acc.no_akaun,
      notis: acc.notis,
  tarikh_borang: onlyDate(tarikh_borang),
  tarikh_notis: onlyDate(tarikh_notis),
  tarikh_simpan: today,
      status_terima: 1,
      bahagian_pemantau: (user.bahagian || '').toUpperCase(),
      id_pengguna: (user.id_pengguna || '').toLowerCase(),
      no_inbois_list: acc.no_inbois_list || [],
    }));
    // Build notisFail (one per session)
  const notisFail = {
      tarikh_borang: onlyDate(tarikh_borang),
      tarikh_notis: onlyDate(tarikh_notis),
      tarikh_simpan: today
    };
    try {
      await apiUploadNotis({ notisList, notisFail, file: files[0] });
      // Refresh parent table (Senarai Notis)
      if (typeof onUpload === 'function') {
        await onUpload();
      }
      showSuccess("Notis berjaya disimpan.");
  // Clear form for next session and close
  resetForm();
  setTimeout(() => { onClose(); }, 10);
    } catch (err) {
      showError("Gagal simpan notis: " + (err.message || err));
    }
  };

  const paginatedAccounts = accounts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          ...dialogHeaderStyles.default,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
        }}
      >
        Senarai Penerimaan Notis
      </DialogTitle>
      <DialogContent>
  <Grid container spacing={2} mt={0.1}>
            <Grid item xs={12} md={12} lg={12}>
            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
              <Box fontWeight='fontWeightMedium' display='inline' color='red'>Nota Penting:</Box><br />
              <Box component="span" color='red'>Pastikan fail adalah berbentuk </Box>
              <Box component="span" fontWeight='fontWeightMedium' color='red'>&ldquo;PDF&rdquo; </Box>
              <Box component="span" color='red'>dan muatnaik </Box>
              <Box component="span" fontWeight='fontWeightMedium' color='red'>&ldquo;SATU&rdquo; </Box>
              <Box component="span" color='red'>borang sahaja.</Box>
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={6} gap={1}>
            <TextField
              label="Tarikh Borang"
              size="small"
              type="date"
              fullWidth
              value={tarikh_borang}
              onChange={(e) => setTarikhBorang(e.target.value)}
              InputLabelProps={{ shrink: true }}
              margin="small"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6} gap={1}>
            <TextField
              label="Tarikh Notis"
              size="small"
              type="date"
              fullWidth
              value={tarikh_notis}
              onChange={(e) => setTarikhNotis(e.target.value)}
              InputLabelProps={{ shrink: true }}
              margin="small"
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Button
              startIcon={<UploadFileIcon />}
              variant="contained"
              component="label"
              size="small"
              fullWidth
              sx={{
                ...buttonStyles.primary,
                m: 0,
                px: 2,
                minWidth: 0
              }}
            >
              UPLOAD BORANG
              <input
                type="file"
                accept="application/pdf"
                hidden
                onChange={handleFileChange}
              />
            </Button>
          </Grid>
        </Grid>
        {files.length > 0 && (
          <div style={{ marginTop: 8, color: isPdf ? 'inherit' : 'red' }}>
            {files.map((f, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4, fontWeight: 'bold', color: 'green' }}>
                <span style={{ fontSize: 12 }}>{f.name}</span>
                <IconButton size="small" onClick={() => handleRemoveFile(f.name)} style={{ color: 'red', marginLeft: 4, alignSelf: 'flex-end' }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </div>
            ))}
            {!isPdf && <span>(Semua fail mesti format PDF)</span>}
          </div>
        )}
        {accounts && accounts.length > 0 && (
          <div style={{ marginBottom: 4 }}>
            <strong style={{ fontSize: 13 }}>Senarai Akaun Terpilih:</strong>
            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 4, fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: '2px 4px', textAlign: 'center', fontSize: 12 }}>NAMA</th>
                  <th style={{ padding: '2px 4px', textAlign: 'center', fontSize: 12 }}>NO AKAUN</th>
                  <th style={{ padding: '2px 4px', textAlign: 'center', fontSize: 12 }}>NOTIS</th>
                </tr>
              </thead>
              <tbody>
                {paginatedAccounts.map((acc, idx) => (
                  <tr key={acc.no_akaun + '-' + acc.nama + '-' + idx}>
                    <td style={{ padding: '2px 4px', fontSize: 12 }}>{acc.nama}</td>
                    <td style={{ padding: '2px 4px', fontSize: 12, textAlign: 'center' }}>{acc.no_akaun}</td>
                    <td style={{ padding: '2px 4px', fontSize: 12, textAlign: 'center' }}>{acc.notis}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* Pagination controls */}
            {accounts.length > rowsPerPage && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 4 }}>
                <Button size="small" variant="outlined" onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0} sx={{ minWidth: 24, px: 1, mx: 0.5, color: '#333' }}>
                  <span style={{ color: '#333' }}>&lt;</span>
                </Button>
                <span style={{ fontSize: 13, margin: '0 12px', fontWeight: 500 }}>
                  {page + 1} / {Math.ceil(accounts.length / rowsPerPage)}
                </span>
                <Button size="small" variant="outlined" onClick={() => setPage((p) => Math.min(Math.ceil(accounts.length / rowsPerPage) - 1, p + 1))} disabled={page >= Math.ceil(accounts.length / rowsPerPage) - 1} sx={{ minWidth: 24, px: 1, mx: 0.5, color: '#333' }}>
                  <span style={{ color: '#333' }}>&gt;</span>
                </Button>
              </div>
            )}
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleUpload}
          variant="contained"
          size="small"
          sx={buttonStyles.save}
          disabled={files.length === 0 || !isPdf}
        >
          Simpan
        </Button>
        <Button
        variant="contained"
          onClick={onClose}
          size="small"
          sx={buttonStyles.cancel}
        >
          Batal
        </Button>
      </DialogActions>
  </Dialog>
    </>
  );
}

TambahTerimaNotis.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onUpload: PropTypes.func,
  accounts: PropTypes.array,
};

export default TambahTerimaNotis;
